import * as Select from "@radix-ui/react-select";
import { ComponentProps, useEffect, useState } from "react";

export interface ContentProps extends ComponentProps<typeof Select.Content> { }

export function Content({ children, ...props }: ContentProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <Select.Portal>
      <Select.Content
        {...props}
        sideOffset={8}
        side="bottom"
        position="popper"
        className="group z-[9999] w-[var(--radix-select-trigger-width)] animate-slideUpAndFade overflow-hidden rounded-lg border border-zinc-200 bg-white will-change-[opacity,transform] dark:border-zinc-700 dark:bg-zinc-800"
        onCloseAutoFocus={(e) => {
          // Prevenir que o foco volte para o trigger quando fechar dentro de um modal
          e.preventDefault();
        }}
        onEscapeKeyDown={(e) => {
          // Prevenir comportamento padrão que pode causar problemas em alguns navegadores
          e.stopPropagation();
        }}
        onPointerDownOutside={(e) => {
          // Prevenir comportamento padrão que pode causar problemas em alguns navegadores
          e.stopPropagation();
        }}
      >
        <Select.Viewport className="max-h-[300px] overflow-y-auto p-1">
          {children}
        </Select.Viewport>
      </Select.Content>
    </Select.Portal>
  );
}
